/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { Body_upload_avatar_api_v1_users_avatar_post } from "../models/Body_upload_avatar_api_v1_users_avatar_post";
import type { DataMessageResponse_AvatarUploadResponse_ } from "../models/DataMessageResponse_AvatarUploadResponse_";
import type { DataMessageResponse_LoginResponse_ } from "../models/DataMessageResponse_LoginResponse_";
import type { DataMessageResponse_Dict_str__Any__ } from "../models/DataMessageResponse_Dict_str__Any__";
import type { DataMessageResponse_UserCreateResponse_ } from "../models/DataMessageResponse_UserCreateResponse_";
import type { DataResponse_Dict_str__Any__ } from "../models/DataResponse_Dict_str__Any__";
import type { MessageOnlyResponse } from "../models/MessageOnlyResponse";
import type { UserCreateRequest } from "../models/UserCreateRequest";
import type { UserTimezoneUpdateRequest } from "../models/UserTimezoneUpdateRequest";
import type { UserUpdateRequest } from "../models/UserUpdateRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class UsersService {
  /**
   * Create User
   * Creates a new user in the database using Clerk id passed in the request and returns a UserCreateResponse with id and email.
   * @param requestBody
   * @returns DataMessageResponse_UserCreateResponse_ Successful Response
   * @throws ApiError
   */
  public static createUserApiV1UsersPost(
    requestBody: UserCreateRequest,
  ): CancelablePromise<DataMessageResponse_UserCreateResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users",
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Current User
   * Used by a user to get information about themselves.
   * @param xUserId
   * @returns DataResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static getCurrentUserApiV1UsersGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/users",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Profile Info
   * Updates a user's profile information.
   * Returns a success message upon completion.
   * @param xUserId
   * @param requestBody
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static updateProfileInfoApiV1UsersPut(
    xUserId: string,
    requestBody: UserUpdateRequest,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/users",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete User
   * Deletes all user data from DynamoDB tables.
   * This will permanently remove:
   * - User profile and preferences (UsersTable)
   * - Meal plans (PlansTable)
   * - Meal suggestions and go-to meals (MealSuggestionsTable)
   * - Shopping lists (ShoppingListTable)
   *
   * Returns a success message upon completion.
   * @param xUserId
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static deleteUserApiV1UsersDelete(
    xUserId: string,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/users",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get User By Admin
   * Used by an admin to get information about a user.
   * @param userId
   * @param xUserId
   * @returns DataResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static getUserByAdminApiV1UsersUserIdGet(
    userId: string,
    xUserId: string,
  ): CancelablePromise<DataResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/users/{user_id}",
      path: {
        user_id: userId,
      },
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Login
   * Returns the user ID and isOnboardingCompleted flag if authentication is successful.
   * @param xUserId
   * @returns DataMessageResponse_LoginResponse_ Successful Response
   * @throws ApiError
   */
  public static loginApiV1UsersLoginPost(
    xUserId: string,
  ): CancelablePromise<DataMessageResponse_LoginResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/login",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Mark Onboarding Completed
   * Marks the user's onboarding as completed by setting isOnboardingCompleted to true.
   * Returns a success message upon completion.
   * @param xUserId
   * @returns MessageOnlyResponse Successful Response
   * @throws ApiError
   */
  public static markOnboardingCompletedApiV1UsersOnboardingCompletedPatch(
    xUserId: string,
  ): CancelablePromise<MessageOnlyResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v1/users/onboarding-completed",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Timezone
   * Updates the user's IANA timezone (e.g. "Australia/Sydney").
   * Hand-added ahead of spec sync -- preserve on regen (see API-CLIENT-REGEN.md).
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_Dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static updateTimezoneApiV1UsersTimezonePatch(
    xUserId: string,
    requestBody: UserTimezoneUpdateRequest,
  ): CancelablePromise<DataMessageResponse_Dict_str__Any__> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/api/v1/users/timezone",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Avatar
   * Upload user avatar profile image.
   *
   * Accepts JPEG and PNG images up to 5MB.
   * Stores image in S3 and updates user profile with avatar URL.
   *
   * ## Parameters:
   * - **avatar**: Image file (JPEG or PNG, max 5MB)
   *
   * ## Returns:
   * - **avatar_url**: S3 URL of the uploaded avatar
   *
   * ## Example:
   * ```bash
   * curl -X POST "http://localhost:5000/api/v1/users/avatar"       -H "x-api-key: your_api_key"       -H "Authorization: Bearer your_token"       -F "avatar=@profile.jpg"
   * ```
   * @param xUserId
   * @param formData
   * @returns DataMessageResponse_AvatarUploadResponse_ Successful Response
   * @throws ApiError
   */
  public static uploadAvatarApiV1UsersAvatarPost(
    xUserId: string,
    formData: Body_upload_avatar_api_v1_users_avatar_post,
  ): CancelablePromise<DataMessageResponse_AvatarUploadResponse_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/avatar",
      headers: {
        "x-user-id": xUserId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
